exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-smcremodeling-index-tsx": () => import("./../../../src/pages/smcremodeling/index.tsx" /* webpackChunkName: "component---src-pages-smcremodeling-index-tsx" */),
  "component---src-pages-smcremodeling-smc-remodeling-tsx": () => import("./../../../src/pages/smcremodeling/SMCRemodeling.tsx" /* webpackChunkName: "component---src-pages-smcremodeling-smc-remodeling-tsx" */)
}

